export default __webpack_public_path__ + "static/media/abogados.263efdab.jpg";